import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import { urlTask, urlTaskSecured, urlGetAllTaskSecured } from "../../api/urls";

import {
  PAGE_SIZE_10,
  CREATE_TASK,
  GET_TASK,
  UPDATE_TASK,
  DELETE_TASK,
  FILTER_TASK,
} from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.code !== undefined) filter += "&code=" + filters.code;
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.namePt !== undefined) filter += "&namePt=" + filters.namePt;
    if (filters.performance !== undefined)
      filter += "&performance=" + filters.performance;
    if (filters.culture !== undefined) filter += "&culture=" + filters.culture;
    if (filters.active !== undefined) filter += "&active=" + filters.active;
    if (filters.description !== undefined)
      filter += "&description=" + filters.description;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

const generateFilterAll = (dataFilter) => {
  let filter = "?";
  if (dataFilter?.filters) {
    if (dataFilter.filters.culture !== undefined)
      filter += "&culture=" + dataFilter.filters.culture;
    if (dataFilter.filters.name !== undefined)
      filter += "&name=" + dataFilter.filters.name;
  }

  return filter;
};
/**
 * Get Task by uuid.
 */
export const getTaskByUuid = createAction(GET_TASK, (param) =>
  apiGet(urlTaskSecured, param, true)()
);

/**
 * Filter list Task.
 */
export const filterTask = createAction(FILTER_TASK, (filter, param) =>
  apiGet(urlTaskSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Create Task.
 */
export const createTask = createAction(CREATE_TASK, (obj) =>
  apiPost(urlTaskSecured, obj, undefined, true)()
);

/**
 * Update Task.
 */
export const modifyTask = createAction(UPDATE_TASK, (obj, param) =>
  apiPut(urlTaskSecured, obj, param, true)()
);

/**
 * Delete Task by uuid.
 */
export const removeTask = createAction(DELETE_TASK, (param) =>
  apiDelete(urlTaskSecured, param, true)()
);

/**
 * Filter list Code.
 */
export const listAll = createAction("LIST_ALL", (filter) =>
  apiGet(urlGetAllTaskSecured + generateFilterAll(filter), undefined, true)()
);
